import { render } from "./TemplateItemFormulaModal.vue?vue&type=template&id=9898265e&scoped=true"
import script from "./TemplateItemFormulaModal.vue?vue&type=script&lang=js"
export * from "./TemplateItemFormulaModal.vue?vue&type=script&lang=js"

import "./TemplateItemFormulaModal.vue?vue&type=style&index=0&id=9898265e&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9898265e"]])

export default __exports__